import { Routes } from "@angular/router";
import { AuthGuard } from "../../auth/helpers";
import { CustomersSiteEditFormComponent } from "./pages/site/edit-form/customers-site-edit-form.component";
import { CustomersSiteAddFormComponent } from "./pages/site/add-form/customers-site-add-form.component";
import { CustomersSitesListComponent } from "./pages/site/list/customers-sites-list.component";
import { CustomersReferentsListComponent } from "./pages/referents/customers-referents-list.component";
import { StatsComponent } from "./pages/stats/stats.component";
import { CustomersListComponent } from "./pages/customer/list/customers-list.component";
import { CustomersAddFormComponent } from "./pages/customer/add/customers-add-form.component";
import { CustomersEditFormComponent } from "./pages/customer/edit/customers-edit-form.component";
import { CustomerDetailComponent } from "./pages/customer/detail/customer-detail.component";
import { CustomerTypeListComponent } from "./pages/customer-type/customer-type-list.component";
import { FteSubjectComponent } from "./pages/fte-subject/fte-subject.component";
import { TrackFinancialRelevanceComponent } from "./pages/track-financial-relevance/track-financial-relevance.component";
import { ServicesTracksComponent } from "./pages/services-tracks/services-tracks.component";
import { BanksListComponent } from "./pages/banks/banks-list.component";

const customerRoutes: Routes = [
  // lista
  {
    path: "dashboard/customers",
    component: CustomersListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/customer/add",
    component: CustomersAddFormComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/customer/edit/:id",
    component: CustomersEditFormComponent,
    canActivate: [AuthGuard],
  },
  // sedi
  {
    path: "dashboard/customers-location",
    component: CustomersSitesListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/list-location/add",
    component: CustomersSiteAddFormComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/list-location/edit/:id",
    component: CustomersSiteEditFormComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/customer/:id",
    component: CustomerDetailComponent,
    canActivate: [AuthGuard],
  },
  // referenti
  {
    path: "dashboard/customers-reference",
    component: CustomersReferentsListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/customers/stats",
    component: StatsComponent,
    canActivate: [AuthGuard],
  },
  // customer type
  {
    path: "dashboard/customers-type",
    component: CustomerTypeListComponent,
    canActivate: [AuthGuard],
  },
  // fte customer type
  {
    path: "dashboard/fte-subject-type",
    component: FteSubjectComponent,
    canActivate: [AuthGuard],
  },
  // track customer financial relevance
  {
    path: "dashboard/customers-track-finance-relevance",
    component: TrackFinancialRelevanceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/services-track",
    component: ServicesTracksComponent,
    canActivate: [AuthGuard],
  },
  //Banks list
  {
    path: "dashboard/banks",
    component: BanksListComponent,
    canActivate: [AuthGuard],
  },
];
export default customerRoutes;
